import { styled } from "styled-components";

export const CartBackContainer = styled.div`
  border: 1px solid #383838;
  height: 100%;
  width: 834px;
  overflow-y: auto;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`;
